module.exports = __webpack_public_path__ + "img/avatar.db60699a.svg";